export default __webpack_public_path__ + "static/media/logo_en.9bb27721.png";